/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Connectionstatus_Disconnected1Inputs */



/**
* | output |
* | --- |
* | "Automate disconnected" |
*
* @param {Alarms_Connectionstatus_Disconnected1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_connectionstatus_disconnected1 = /** @type {((inputs?: Alarms_Connectionstatus_Disconnected1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Connectionstatus_Disconnected1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Automate disconnected")
	return /** @type {LocalizedString} */ ("Automate déconnecté")
});
export { alarms_connectionstatus_disconnected1 as "alarms_connectionStatus_disconnected" }